<template>
  <footer>
    <div>
      <p>Xster by XW © 2025 All Rights Reserved</p>
      <p>Xster 版权所有</p>

      <p class="footer-links">
        <router-link to="/about" class="footer-link">关于我们</router-link>
        <span class="footer-separator">|</span>
        <router-link to="/contact" class="footer-link">联系我们</router-link>
        <span class="footer-separator">|</span>
        <router-link to="/privacy" class="footer-link">隐私政策</router-link>
        <span class="footer-separator">|</span>
        <router-link to="/terms" class="footer-link">使用条款</router-link>
      </p>

      <p>
        <a class="footer-beian" href="https://beian.miit.gov.cn">
          京ICP备2025146383号-1
        </a>

        <a
          class="footer-beian"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802029881"
        >
          <img src="../../assets/beian-logo.png" />
          <span>京公网安备 11010802029881号</span>
        </a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  margin: 0;
  padding: 24px 16px;
  width: 100%;
  color: #888;
  text-align: center;
  font-family: "JetBrains Mono", "Inter", monospace;
  font-size: 0.8rem;
  border-top: 1px solid #eaeaea;
  background: #ffffff;
  flex-shrink: 0;
}

.footer-beian {
  color: #888;
  margin-right: 10px;
  text-decoration: none;
}

.footer-beian:hover {
  color: #0a0a0a;
}

.footer-beian img {
  vertical-align: middle;
  margin-right: 4px;
}

.footer-links {
  margin: 10px 0;
}

.footer-link {
  color: #888;
  text-decoration: none;
  margin: 0 5px;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #0a0a0a;
}

.footer-separator {
  color: #ccc;
  margin: 0 8px;
}

p {
  margin: 0;
  padding: 0;
}
</style>
